import { RouteLocationRaw } from "vue-router"
import { useAcl } from "vue-simple-acl"
import isEqual from "lodash/isEqual"

import { businessPlanPages, Project, User } from "@/models"
import { $keycloak } from "@/plugins/keycloak"
import { Actions, Getters, store } from "@/store"

export default async (
  to,
  from,
  next: (arg?: RouteLocationRaw) => void
): Promise<void | boolean> => {
  const auth = $keycloak.authenticated
  if (!auth || to.name === from.name) {
    next()
    return
  }
  if (!useAcl().can("hasSubscription") && businessPlanPages.includes(to.name as string)) {
    return next({
      name: "SubscriptionError",
      params: {
        accountId: to.params.accountId
      },
      query: {
        f: to.name
      }
    })
  }
  if (!useAcl().can("hasSubscription") && to.name === "create-project") {
    const projects = await store.dispatch(Actions.GET_PROJECTS)
    if (projects && projects.length > 0) {
      return next({
        name: "SubscriptionError",
        params: {
          accountId: to.params.accountId
        },
        query: {
          f: to.name
        }
      })
    }
  }
  const account = store.getters[Getters.GET_ACCOUNT]
  const projectId = store.getters[Getters.GET_SESSION_PROJECT_ID]
  if (account && !useAcl().can("hasSubscription")) {
    const team = store.getters[Getters.GET_SESSION_TEAM]
    if (
      (to.params.teamId && team && account.teamIdsIncludedInSubscription[team.id] === false) ||
      (to.params.projectId && account.projectIdsIncludedInSubscription[projectId] === false)
    ) {
      return next({
        name: "SubscriptionError",
        params: {
          accountId: to.params.accountId
        },
        query: {
          f: to.name
        }
      })
    }
  }
  const isAdmin = useAcl().can.any(["superAdmin", "admin"])
  if (!to.params.projectId || !projectId) {
    return next()
  }
  let currentProject: Project = store.getters[Getters.GET_PROJECT]
  if (currentProject.urlName !== to.params.projectId) {
    currentProject = await store.dispatch(Actions.GET_PROJECT, {
      projectId
    })
  }
  if (
    (to.name === "Item" &&
      currentProject.multiProjectPermission !== "DO_NOT_DISPLAY_BACKLOG_ITEMS") ||
    isAdmin
  ) {
    return next()
  }
  const profile: User = store.getters[Getters.GET_USER_CURRENT_PROFILE]
  const { projects } = profile

  if (!projects) {
    return next()
  }
  if (projects.every(p => p.id !== projectId) && !currentProject.demo) {
    return next({
      name: "Error",
      query: {
        code: "403P"
      }
    })
  }
  return next()
}
